<template>
  <section class="instructions">
    <header class="section-header">

    </header>
    <div class="section-body">
      <h3 class="h4">Background</h3>
      <p>This exercise is designed to create awareness around positive character traits, otherwise known as
         strengths.</p>
      <h3 class="h4">Process Overview</h3>
      <p class="mb-0">
        This is a three step exercise.
      </p>
      <ul>
        <li>In the first step, you will be asked to provide a list of role models from throughout your life.</li>
        <li>In the second step, you will be asked to name positive character traits each of these role models embodied.</li>
        <li>Last, you will be guided through reflection as they pertain to the results.</li>
      </ul>
    </div>

    <!-- Next Step -->
    <footer class="section-footer">
      <div class="next-prev-step">
        <button class="button filled accent-1 begin"
                @click.prevent="$parent.nextStep(); $parent.workStarted ++">
          {{ $parent.workStarted ? "Continue" : "Get Started" }}
        </button>
      </div>
    </footer>
  </section>
  <section class="privacy-notice">
    <div class="section-body">
      <p class="notice">
        <strong>Notice: </strong>
        <i>The results of this exercise are private. No data is captured nor stored throughout the process. You will be
           prompted to download a PDF of your responses when complete. This PDF is generated on demand and will not be
           saved for future review.</i>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
  },
  computed: {},
  methods:  {}
}
</script>
